// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_maintenance-container__d5Q1P {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(145deg, #121119, rgb(7.0714285714, 6.6785714286, 9.8214285714));
  font-family: "Inter", sans-serif;
  color: #ffffff;
  padding: 1rem;
  position: relative;
}
.style_maintenance-container__d5Q1P::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 75% 25%, rgba(138, 43, 226, 0.05), transparent 60%);
  pointer-events: none;
}

.style_logo__cx4Js {
  position: absolute;
  top: -60px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  z-index: 10;
}
.style_logo__cx4Js img {
  max-width: 180px;
  height: auto;
}

.style_maintenance-card__A6xmQ {
  background-color: rgba(27, 26, 36, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 3rem;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  text-align: center;
  border: 1px solid rgba(232, 62, 140, 0.1);
  position: relative;
  margin-top: 60px;
}
.style_maintenance-card__A6xmQ h1 {
  background: linear-gradient(to right, #e83e8c, #8a2be2);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 600;
  font-size: 1.6rem;
  margin: 1rem 0 1.5rem;
  letter-spacing: -0.5px;
}
.style_maintenance-card__A6xmQ p {
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.5;
  font-size: 0.95rem;
  margin-bottom: 0.5rem;
}
.style_maintenance-card__A6xmQ p a {
  color: #e83e8c;
  text-decoration: none;
  transition: all 0.3s ease;
  font-weight: 600;
}
.style_maintenance-card__A6xmQ p a:hover {
  color: #8a2be2;
  text-shadow: 0 0 3px rgba(138, 43, 226, 0.2);
  text-decoration: none;
}

.style_icon__UuUC1 {
  width: 90px;
  height: 90px;
  margin: 1.25rem auto;
  display: block;
  object-fit: contain;
}

.style_highlight__KcbDW {
  color: #e83e8c;
  font-weight: 500;
}

.style_divider__psu7\\+ {
  height: 1px;
  background: linear-gradient(to right, transparent, rgba(232, 62, 140, 0.3), rgba(138, 43, 226, 0.3), transparent);
  margin: 1.5rem 0;
}

.style_contact__s1CKI {
  padding: 0.75rem;
  background-color: rgba(18, 17, 25, 0.4);
  border-radius: 12px;
}
.style_contact__s1CKI p {
  font-size: 0.85rem;
  margin-bottom: 0.25rem;
}
.style_contact__s1CKI a {
  color: #e83e8c;
  text-decoration: none;
  transition: all 0.3s ease;
  font-weight: 500;
  font-size: 0.9rem;
}
.style_contact__s1CKI a:hover {
  color: #8a2be2;
  text-shadow: 0 0 3px rgba(138, 43, 226, 0.2);
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/Maintenance/style.module.scss"],"names":[],"mappings":"AA6BA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,2FAAA;EAKA,gCAAA;EACA,cApCW;EAqCX,aAAA;EACA,kBAAA;AAhCF;AAiCE;EACE,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,yFAAA;EAKA,oBAAA;AAnCJ;;AAuCA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AApCF;AAsCE;EACE,gBAAA;EACA,YAAA;AApCJ;;AAwCA;EACE,uCAtEO;EAuEP,2BAAA;EACA,mBAvEY;EAwEZ,aAAA;EACA,WAAA;EACA,gBAAA;EACA,2CAAA;EACA,kBAAA;EACA,yCAAA;EACA,kBAAA;EACA,gBAAA;AArCF;AAuCE;EA7EA,uDAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;EA4EE,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AAlCJ;AAqCE;EACE,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AAnCJ;AAqCI;EApFF,cAfY;EAgBZ,qBAAA;EACA,yBAZW;EAgGP,gBAAA;AAhCN;AAlDE;EACE,cAnBY;EAoBZ,4CAAA;EACA,qBAAA;AAoDJ;;AAgCA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;AA7BF;;AAgCA;EACE,cAnHY;EAoHZ,gBAAA;AA7BF;;AAgCA;EACE,WAAA;EACA,iHAAA;EAOA,gBAAA;AAnCF;;AAsCA;EACE,gBAAA;EACA,uCAAA;EACA,mBAlIY;AA+Fd;AAqCE;EACE,kBAAA;EACA,sBAAA;AAnCJ;AAqCE;EA7HA,cAfY;EAgBZ,qBAAA;EACA,yBAZW;EAaX,gBAAA;EA4HE,iBAAA;AAhCJ;AA3FE;EACE,cAnBY;EAoBZ,4CAAA;EACA,qBAAA;AA6FJ","sourcesContent":["@use \"sass:color\";\n\n$primary-dark: #121119;\n$accent-pink: #e83e8c;\n$accent-purple: #8a2be2;\n$text-color: #ffffff;\n$box-bg: rgba(#1b1a24, 0.9);\n$card-radius: 12px;\n$transition: all 0.3s ease;\n\n@mixin gradient-text {\n  background: linear-gradient(to right, $accent-pink, $accent-purple);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n@mixin link-styles {\n  color: $accent-pink;\n  text-decoration: none;\n  transition: $transition;\n  font-weight: 500;\n  &:hover {\n    color: $accent-purple;\n    text-shadow: 0 0 3px rgba($accent-purple, 0.2);\n    text-decoration: none;\n  }\n}\n\n.maintenance-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: linear-gradient(\n    145deg,\n    $primary-dark,\n    color.adjust($primary-dark, $lightness: -5%)\n  );\n  font-family: \"Inter\", sans-serif;\n  color: $text-color;\n  padding: 1rem;\n  position: relative;\n  &::before {\n    content: \"\";\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: radial-gradient(\n      circle at 75% 25%,\n      rgba($accent-purple, 0.05),\n      transparent 60%\n    );\n    pointer-events: none;\n  }\n}\n\n.logo {\n  position: absolute;\n  top: -60px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  justify-content: center;\n  z-index: 10;\n\n  img {\n    max-width: 180px;\n    height: auto;\n  }\n}\n\n.maintenance-card {\n  background-color: $box-bg;\n  backdrop-filter: blur(10px);\n  border-radius: $card-radius;\n  padding: 3rem;\n  width: 100%;\n  max-width: 500px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n  text-align: center;\n  border: 1px solid rgba($accent-pink, 0.1);\n  position: relative;\n  margin-top: 60px;\n\n  h1 {\n    @include gradient-text;\n    font-weight: 600;\n    font-size: 1.6rem;\n    margin: 1rem 0 1.5rem;\n    letter-spacing: -0.5px;\n  }\n\n  p {\n    color: rgba($text-color, 0.85);\n    line-height: 1.5;\n    font-size: 0.95rem;\n    margin-bottom: 0.5rem;\n\n    a {\n      @include link-styles;\n      font-weight: 600;\n    }\n  }\n}\n\n.icon {\n  width: 90px;\n  height: 90px;\n  margin: 1.25rem auto;\n  display: block;\n  object-fit: contain;\n}\n\n.highlight {\n  color: $accent-pink;\n  font-weight: 500;\n}\n\n.divider {\n  height: 1px;\n  background: linear-gradient(\n    to right,\n    transparent,\n    rgba($accent-pink, 0.3),\n    rgba($accent-purple, 0.3),\n    transparent\n  );\n  margin: 1.5rem 0;\n}\n\n.contact {\n  padding: 0.75rem;\n  background-color: rgba($primary-dark, 0.4);\n  border-radius: $card-radius;\n\n  p {\n    font-size: 0.85rem;\n    margin-bottom: 0.25rem;\n  }\n  a {\n    @include link-styles;\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"maintenance-container": `style_maintenance-container__d5Q1P`,
	"logo": `style_logo__cx4Js`,
	"maintenance-card": `style_maintenance-card__A6xmQ`,
	"icon": `style_icon__UuUC1`,
	"highlight": `style_highlight__KcbDW`,
	"divider": `style_divider__psu7+`,
	"contact": `style_contact__s1CKI`
};
export default ___CSS_LOADER_EXPORT___;
